import type { TMessages } from '@/types/TMessages'

export const messages = {
  location: 'Регион',
  farm: 'Площадь хозяйства',
} satisfies TMessages
